import { FC } from "react";
import { Layout, Menu } from "antd";
import type { MenuProps } from "antd";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes";

const { Sider } = Layout;

const LeftNav: FC = () => {
  const navigate = useNavigate();

  const items: MenuProps["items"] = [
    {
      key: "left-nav-overview",
      label: "Overview",
      onClick: () => {
        navigate(routes.default);
      },
    },
    {
      key: "left-nav-acquisition",
      label: "Acquisition & Activation",
      onClick: () => {
        navigate(routes.acquisition);
      },
    },
    {
      key: "left-nav-funnel",
      label: "Funnel Analysis",
      onClick: () => {
        navigate(routes.funnel);
      },
    },
    {
      key: "left-nav-cohort",
      label: "Cohort Retention",
      onClick: () => {
        navigate(routes.cohort);
      },
    },
  ];

  return (
    <>
      <Sider width={260} style={{ background: "#ffffff" }}>
        <Menu
          defaultSelectedKeys={["1"]}
          mode="inline"
          theme="light"
          style={{ height: "100%", borderRight: 0 }}
          items={items}
          className="left-nav"
        />
      </Sider>
    </>
  );
};

export default LeftNav;
